<template>
  <div class="min-h-screen bg-gray-100 flex items-center justify-center px-4">
    <div class="max-w-md w-full bg-white p-8 rounded-lg shadow-lg">
      <h2 class="text-2xl font-bold text-center text-gray-800 mb-6">Sign In</h2>
      
      <!-- inline error message -->
      <p v-if="error" class="text-red-500 text-center mb-4">{{ error }}</p>
      
      <form @submit.prevent="onSubmit" class="space-y-4">
        <div>
          <label for="username" class="block text-sm font-medium text-gray-700">Username</label>
          <input
            id="username"
            type="text"
            v-model="username"
            required
            class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
          <input
            id="password"
            type="password"
            v-model="password"
            required
            class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <button
          type="submit"
          :disabled="isLoading"
          class="w-full py-2 px-4 bg-primary text-black rounded-md font-semibold hover:bg-primary/90 transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="isLoading">Signing In...</span>
          <span v-else>Sign In</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter }     from 'vue-router'
import store             from '@/store'

const username = ref('')
const password = ref('')

// getters from Vuex
const isLoading = computed(() => store.getters['auth/isLoading'])
const error     = computed(() => store.getters['auth/authError'])
const isAuth    = computed(() => store.getters['auth/isAuthenticated'])

const router = useRouter()

// redirect if already logged in
onMounted(() => {
  if (isAuth.value) {
    const user = store.getters['auth/currentUser']
    const org = String(user?.organization ?? '').toLowerCase()
    if (org === 'directtide') {
      if ([28, 29, 30, 31].includes(Number(user?.id))) {
        router.replace({ name: 'LeadsTable' })
      } else {
        router.replace({ name: 'Invoices' })
      }
    } else {
      router.replace({ name: 'LeadsTable' })
    }
  }
})

async function onSubmit() {
  try {
    await store.dispatch('auth/login', {
      username: username.value,
      password: password.value
    })
    const user = store.getters['auth/currentUser']
    const org = String(user?.organization ?? '').toLowerCase()
    if (org === 'directtide') {
      if ([28, 29, 30, 31].includes(Number(user?.id))) {
        router.push({ name: 'LeadsTable' })
      } else {
        router.push({ name: 'Invoices' })
      }
    } else {
      router.push({ name: 'Dashboard' })
    }
  } catch {
    // error is already set in store; inline message will show
  }
}
</script>
